/**
 *
 * @module createPaymentMethodRequest
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

import CreatePaymentMethodPassthroughData from './createPaymentMethodPassthroughData';

const {
    number,
    nonEmptyString,
    instanceStrict
} = Check.assert;

/**
 *
 * @class CreatePaymentMethodRequest
 *
 */
export default class CreatePaymentMethodRequest {

    /**
     *
     * @param {String} creditCardNumber
     * @param {Number} namespaceId
     * @param {CreatePaymentMethodPassthroughData} passthroughData
     * @throws {InvalidArgumentException}
     *
     */
    constructor(creditCardNumber, namespaceId, passthroughData) {

        const errorMessage = {
            ctor: 'CreatePaymentMethodRequest(creditCardNumber, namespaceId, passthroughData)',
            get creditCardNumber() {
                return `${this.ctor} creditCardNumber should be a non-empty String`;
            },
            get namespaceId() {
                return `${this.ctor} namespaceId should be a Number`;
            },
            get passthroughData() {
                return `${this.ctor} passthroughData should be an instance of CreatePaymentMethodPassthroughData`;
            }
        };

        nonEmptyString(creditCardNumber, errorMessage.creditCardNumber, InvalidArgumentException);
        number(namespaceId, errorMessage.namespaceId, InvalidArgumentException);

        instanceStrict(
            passthroughData,
            CreatePaymentMethodPassthroughData,
            errorMessage.passthroughData,
            InvalidArgumentException
        );

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.creditCardNumber = creditCardNumber;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.namespaceId = namespaceId;

        /**
         *
         * @access public
         * @type {CreatePaymentMethodPassthroughData}
         *
         */
        this.passthroughData = passthroughData;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/createPaymentMethodRequest.js